import useSWR from 'swr';

import { fetchCameraForecast } from 'common/api/kbyg';

const DEFAULT_DAYS = 16;

export interface UseCameraForecastArgs {
  spotId: string | undefined;
  days?: number;
  enabled?: boolean;
}

const useCameraForecast = ({
  spotId,
  days = DEFAULT_DAYS,
  enabled = true,
}: UseCameraForecastArgs) => {
  const swrKey = enabled && spotId ? (['camera-forecast', spotId, days] as const) : null;

  return useSWR(swrKey, ([, id, d]) => fetchCameraForecast({ id, days: d }), {
    errorRetryCount: 0,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnMount: true,
    revalidateOnReconnect: false,
  });
};

export default useCameraForecast;
